import type { ChangeBrief, EvidencePacket } from "../shared/schema";

export function createDryRunPacket(change: ChangeBrief, now = new Date()): EvidencePacket {
  const samples = [
    ["Yes — customer_contact is the preferred name.", "Owner confirmed the new name is clearer for email and phone values."],
    ["Two exports still read customer_email directly.", "Owner named the lifecycle export and support handoff as direct consumers."],
    ["The proposed length is sufficient.", "Owner confirmed 320 characters covers known values."],
    ["Keep both fields available for 14 days.", "Owner requested a two-week compatibility window."],
  ];

  return {
    decision: "approve_with_conditions",
    ownerSummary: "Proceed after the two direct consumers move, with a 14-day dual-field transition.",
    answers: change.questions.map((question, index) => ({
      questionId: question.id,
      answer: samples[index]?.[0] ?? "No additional constraint was raised.",
      evidence: samples[index]?.[1] ?? "Dry-run owner response acknowledged the question.",
    })),
    conditions: [
      "Migrate the lifecycle export and support handoff first.",
      "Keep both fields readable for 14 days.",
    ],
    transcript: [
      { speaker: "CALL-E", text: "I’m an AI calling for the data platform team about a proposed field change. Is now a good time to continue?" },
      { speaker: "Owner", text: "Yes, I can review it now." },
      { speaker: "CALL-E", text: "Will any systems or contracts break because of this rename?" },
      { speaker: "Owner", text: "Two exports still use customer_email directly. Give us two weeks with both fields." },
      { speaker: "CALL-E", text: "I captured two consumers and a 14-day transition. Is that accurate?" },
      { speaker: "Owner", text: "Yes, that’s right." },
    ],
    callId: null,
    createdAt: now.toISOString(),
    source: "dry_run",
  };
}
